export default {
    "export": {
        "library_folder": {
            "class": "app\\build\\astra\\exportImport\\services\\FolderExportService",
            "permissions": []
        },
        "card": {
            "class": "app\\build\\astra\\exportImport\\services\\CardExportService",
            "permissions": []
        }
    },
    "import": {
        "users": {
            "class": "app\\build\\astra\\exportImport\\services\\UsersImportService",
            "permissions": [],
            "example": "UsersImport.xlsx"
        }
    }
}